import KioskPublicationSection from "@/components/KioskPublicationSection";
import { useCategoriesQuery } from "@/stores/api";
import { Issue } from "@/stores/types";
import { Box, CircularProgress, Container } from "@mui/material";

import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

interface Props {}

export default function Home(props: Props) {
  const { data: categories, isLoading } = useCategoriesQuery();
  const navigate = useNavigate();
  const Loading = useMemo(() => {
    if (isLoading) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      );
    }
    return null;
  }, [isLoading]);

  const onPressIssue = (issue: Issue) => {
    // const jwt = generateToken(issue);
    // window.location.href = `${process.env.REACT_APP_READER_URL}${jwt}`;
    navigate(`/publication/${issue.id}`);
  };

  return (
    <Container maxWidth={false} sx={{ flex: 1 }}>
      <Typography sx={{ textAlign: "center", my: 3 }} variant="body1">
        Pour célébrer la coupe du monde de Rugby, les Salons Grand Voyageur vous
        offrent 3 mois d’abonnement à l’offre digitale de Midi Olympique.
      </Typography>

      {Loading}

      {categories?.map((category) => {
        return (
          <KioskPublicationSection
            key={category.id}
            category={category}
            onPressIssue={onPressIssue}
          />
        );
      })}
    </Container>
  );
}
